import { HEADER_SETTING_OVERRIDE } from "@faire/web/common/consts/HEADER_SETTING_OVERRIDE";
import { getSettingOverrideHeader } from "@faire/web/common/PublicSettings";

import { headerInterceptorFactory } from "./headerInterceptor";

export const settingOverridesInterceptor = headerInterceptorFactory({
  header: HEADER_SETTING_OVERRIDE,
  value: getSettingOverrideHeader,
});
